import React, { useEffect, useState } from "react";
import "./electricalInfo.css";
import { useSelector, useDispatch } from "react-redux";
import { inverterInformation } from "../../DataFiles/inverterInformation";
import {
  handleInverterList,
  handleInverterType,
  handlePhase,
  handleSystemType,
  handleCommunicationDevice,
  handlePowerSensor,
  handleOneLineMethod,
  handleElectricalConfiguration,
  handleApply,
} from "./electricalFunction";
import {
  updateQuantityInfo,
  updateRoofInverterAnalysis,
} from "../../../Features/quantityInfo";
import { updateInverterAnalysis } from "../../../Features/roofInfo";
import Modal from "react-bootstrap/Modal";
import InverterPreview from "./inverterPreview";
import CustomInput from "../../../component/customInput";
import { Autocomplete, TextField } from "@mui/material";
import CustomInputLabel from "../../../component/customInputLabel";
import Grid from "@mui/material/Grid2";

export default function InfoContainer({ emptyValues }) {
  const roofInfo = useSelector((state) => state.roof);
  const quantityInfo = useSelector((state) => state.quantity);
  const [preview, setPreview] = useState(false);
  const handleClose = () => setPreview(false);
  const [tooltip, setTooltip] = useState();
  const [checkCombine, setCheckCombine] = useState(false);
  const roofData = quantityInfo?.roofData || [];
  const roofIndex = quantityInfo.roofNo;
  let check = quantityInfo.allRoof;
  const roofDetail = roofData[roofIndex];
  let inverterDetail = [];

  useEffect(() => {
    if (roofData.length > 1) {
      for (let i = 0; i < roofData.length; i++) {
        const element = roofData[i].moduleType;
        const value = roofData[0].moduleType;
        if (value === element) {
          setCheckCombine(true);
        } else {
          setCheckCombine(false);
          handleElectricalConfiguration("Single Roof", dispatch);
        }
      }
    }
    // eslint-disable-next-line
  }, []);

  if (check && quantityInfo.electricalConfiguration === "All Roof") {
    inverterDetail = roofInfo.value.inverterAnalysis;
  } else {
    inverterDetail = roofDetail.inverterAnalysis;
  }

  const dispatch = useDispatch();
  let list = inverterInformation.filter(
    (item) =>
      item.phase === inverterDetail.inverterPhase &&
      item.systemType === inverterDetail.systemType
  );
  const [inverterList, setInverterList] = useState(list);
  const [powerSensorList, setPowerSensorList] = useState(["No Power Sensor"]);
  const [communicationDevice, setCommunicationDevice] = useState([
    "No Communication Device",
  ]);

  const [inverterTypeList, setInverterTypeList] = useState([
    { name: "Select a inverter manufacturer." },
  ]);

  useEffect(() => {
    const value = inverterDetail;
    if (
      quantityInfo.electricalConfiguration === "Single Roof" &&
      !checkCombine
    ) {
      dispatch(updateQuantityInfo({ allRoof: false }));
    }
    if (value.inverterManufacturer !== "Select") {
      let inverter = inverterInformation.find(
        (item) =>
          item.brand === value.inverterManufacturer &&
          item.phase === value.inverterPhase &&
          item.systemType === value.systemType
      );
      setTimeout(() => {
        handleInverterList({
          inverter,
          dispatch,
          setInverterTypeList,
          roofDetail,
          inverterDetail,
          quantityInfo,
          setPowerSensorList,
          setCommunicationDevice,
        });
        if (value.inverterType !== "Select") {
          let type = inverter.inverterType.find(
            (item) => item.name === value.inverterType
          );

          setTimeout(() => {
            handleInverterType({
              type,
              dispatch,
              roofInfo,
              roofDetail,
              inverterDetail,
              quantityInfo,
              setCommunicationDevice,
            });
          }, 100);
        }
      }, 100);
    }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const selectedBrand = inverterDetail?.inverterManufacturer;
    const selectedInverter = inverterList.find(
      (item) => item.brand === selectedBrand
    );
    if (selectedInverter) {
      handleInverterList({
        inverter: selectedInverter,
        dispatch,
        setInverterTypeList,
        roofDetail,
        inverterDetail,
        quantityInfo,
        setPowerSensorList,
        setCommunicationDevice,
      });
    }
    // eslint-disable-next-line
  }, [inverterDetail?.inverterManufacturer]);

  const handleDCACRatio = (e) => {
    if (check) {
      dispatch(
        updateInverterAnalysis({
          DCACRatio: e.target.value,
        })
      );
    } else {
      dispatch(
        updateRoofInverterAnalysis({
          index: roofIndex,
          fields: {
            DCACRatio: e.target.value,
          },
        })
      );
    }
  };

  return (
    <>
      <div className="EinfoContainer">
        <div className="siteDetail">
          <h1>Inverter</h1>
          {roofData.length > 1 && (
            <div className="selectionButton">
              <div className={`structureBtn`}>
                <button
                  onClick={() => {
                    !checkCombine
                      ? alert(
                          "Combining electrical configurations is restricted due to different types of panels for different roofs. If you want to combine electrical configurations, you need to select the same panel type on the design page for each roof."
                        )
                      : handleElectricalConfiguration("All Roof", dispatch);
                  }}
                  style={{
                    backgroundColor:
                      quantityInfo.electricalConfiguration === "All Roof"
                        ? "#ff7f1e"
                        : "#072a4066",
                  }}
                >
                  Combined Roof Configuration
                </button>
              </div>
              <div className="structureBtn">
                <button
                  onClick={() =>
                    handleElectricalConfiguration("Single Roof", dispatch)
                  }
                  style={{
                    backgroundColor:
                      quantityInfo.electricalConfiguration === "Single Roof"
                        ? "#ff7f1e"
                        : "#072a4066",
                  }}
                >
                  Separate Roof Configuration
                </button>
              </div>
            </div>
          )}
          <div className="formWithLabel">
            <label>System type:</label>
            <div
              className="checkGrid"
              onClick={(e) =>
                handleSystemType(
                  e,
                  setInverterList,
                  dispatch,
                  quantityInfo,
                  inverterDetail
                )
              }
            >
              <div className="option">
                <input
                  type="radio"
                  id="On Grid"
                  name="systemType"
                  value="On Grid"
                  defaultChecked={inverterDetail.systemType === "On Grid"}
                />
                <label htmlFor="On Grid">On Grid</label>
              </div>
              <div className="option">
                <input
                  type="radio"
                  id="Hybrid"
                  name="systemType"
                  value="Hybrid"
                  defaultChecked={inverterDetail.systemType === "Hybrid"}
                />
                <label htmlFor="Hybrid">Hybrid</label>
              </div>
            </div>
          </div>
          <div className="formWithLabel">
            <label>Phase:</label>
            <div
              className="checkGrid"
              onClick={(e) =>
                handlePhase(
                  e,
                  setInverterList,
                  dispatch,
                  quantityInfo,
                  inverterDetail
                )
              }
            >
              <div className="option">
                <input
                  type="radio"
                  id="Single Phase"
                  name="phase"
                  value="Single Phase"
                  defaultChecked={
                    inverterDetail.inverterPhase === "Single Phase"
                  }
                />
                <label htmlFor="Single Phase">Single Phase</label>
              </div>
              <div className="option">
                <input
                  type="radio"
                  id="Three Phase"
                  name="phase"
                  value="Three Phase"
                  defaultChecked={
                    inverterDetail.inverterPhase === "Three Phase"
                  }
                />
                <label htmlFor="Three Phase">Three Phase</label>
              </div>
            </div>
          </div>

          <div className="formWithLabel">
            <label>Configuration Method:</label>
            <div className="checkGrid">
              <div className="option">
                <input
                  type="radio"
                  id="MPPT"
                  name="oneLineMethod"
                  value="MPPT"
                  checked={inverterDetail.oneLineMethod === "MPPT"}
                  onChange={(e) =>
                    handleOneLineMethod(
                      e,
                      dispatch,
                      quantityInfo,
                      roofInfo,
                      inverterDetail,
                      roofDetail,
                      setCommunicationDevice
                    )
                  }
                />
                <label htmlFor="MPPT">MPPT</label>
              </div>
              <div className="option">
                <input
                  type="radio"
                  id="strings/MPPT"
                  name="oneLineMethod"
                  value="strings/MPPT"
                  checked={inverterDetail.oneLineMethod === "strings/MPPT"}
                  onChange={(e) =>
                    handleOneLineMethod(
                      e,
                      dispatch,
                      quantityInfo,
                      roofInfo,
                      inverterDetail,
                      roofDetail,
                      setCommunicationDevice
                    )
                  }
                />
                <label htmlFor="strings/MPPT">Strings/MPPT</label>
              </div>
            </div>
          </div>

          <CustomInput
            id="DCACRatio"
            name="DCACRatio"
            title="DC/AC"
            value={inverterDetail.DCACRatio}
            onChange={(e) => handleDCACRatio(e)}
            required={true}
            placeholder="DC/AC ratio"
            width="100%"
            type="number"
          />
          <CustomInputLabel title={"Inverter Manufacturer"} />
          <Autocomplete
            id="inverter-manufacturer-autocomplete"
            options={inverterList.map((item) => item.brand)}
            value={inverterDetail?.inverterManufacturer || null}
            onChange={(event, newValue) => {
              const selectedBrand = newValue;
              const selectedInverter = inverterList.find(
                (item) => item.brand === selectedBrand
              );
              if (selectedInverter) {
                handleInverterList({
                  inverter: selectedInverter,
                  dispatch,
                  setInverterTypeList,
                  roofDetail,
                  inverterDetail,
                  quantityInfo,
                  setPowerSensorList,
                  setCommunicationDevice,
                });
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder="Select Inverter Manufacturer"
              />
            )}
          />
          <Grid sx={{ display: "flex", alignItems: "center" }}>
            <CustomInputLabel title={"Inverter Type"} />
            {inverterDetail.inverterType !== "Select" && (
              <h6
                className="preview"
                onClick={() => setPreview(true)}
                onMouseEnter={() => setTooltip("preview")}
                onMouseLeave={() => setTooltip()}
              >
                {tooltip === "preview" && (
                  <span className="warning">
                    <div className="sideArrow"></div>
                    Preview Inverter Datasheet
                  </span>
                )}
                <i className="bi bi-eye-fill"></i>
                <span>Preview</span>
              </h6>
            )}
          </Grid>
          <Autocomplete
            options={inverterTypeList.map((item) => item.name)} // Extract names
            getOptionLabel={(option) => option}
            value={inverterDetail?.inverterType || null}
            onChange={(event, value) => {
              const selectedInverter = inverterTypeList.find(
                (item) => item.name === value
              );
              if (selectedInverter) {
                handleInverterType({
                  type: selectedInverter,
                  dispatch,
                  roofInfo,
                  roofDetail,
                  inverterDetail,
                  quantityInfo,
                  setCommunicationDevice,
                });
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder="select inverter type"
              />
            )}
          />

          <CustomInputLabel title="Power Sensor" />
          <Autocomplete
            options={powerSensorList}
            value={inverterDetail?.powerSensor || null}
            onChange={(event, newValue) => {
              handlePowerSensor(newValue, dispatch, quantityInfo);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder="No Power Sensor"
              />
            )}
          />
          <CustomInputLabel title="Communication Device" />
          <Autocomplete
            options={communicationDevice}
            value={inverterDetail?.communicationDevice || null}
            onChange={(event, newValue) => {
              handleCommunicationDevice(newValue, dispatch, quantityInfo);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder="No Power Sensor"
              />
            )}
          />

          {/* {inverterDetail.inverterType !== "Select" && <ElectricalEquipment />} */}

          {inverterDetail.inverterType !== "Select" && (
            <div className="updateContainer">
              <div
                className="updateButton"
                onClick={() => {
                  handleApply({
                    dispatch,
                    roofInfo,
                    roofDetail,
                    inverterDetail,
                    quantityInfo,
                    setCommunicationDevice,
                  });
                }}
              >
                Apply
              </div>
            </div>
          )}
        </div>
      </div>

      <Modal
        show={preview}
        onHide={handleClose}
        keyboard={false}
        centered
        className="datasheetModal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Inverter Datasheet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InverterPreview inverterDetail={inverterDetail}></InverterPreview>
        </Modal.Body>
      </Modal>
    </>
  );
}
